import React from 'react'
import { pricingThreeData } from '../data/data'
import { Link } from 'react-router-dom'

import {FiArrowRightCircle } from '../assets/icons/vander'

export default function PricingThree() {
  return (
    <div className="row align-items-center">
        {pricingThreeData.map((item,index)=>{
            return(
                <div className="col-lg-4 col-md-6 col-12 mt-4 pt-2" key={index}>
                    <div className="pricing text-center rounded overflow-hidden shadow">
                        <div className="price-header bg-dark pt-5 pb-5">
                            <h4 className="price-title text-white mb-0">{item.title}</h4>
                        </div>
                        <div className="bg-light shadow py-4">
                            <div className="d-flex text-primary justify-content-center">
                                <span className="h5 mb-0">$</span>
                                <span className="price h2 fw-bold mb-0 ms-1">{item.value}</span>
                            </div>
                            <span className="h6 align-self-end mb-1">{item.time}</span>
                        </div>
                        <div className="pricing-features text-start">
                            <ul className="list-unstyled py-4 p-3 mb-0 ">
                                {item.feature.map((el,index)=>{
                                    return(
                                        <li className="feature-list text-muted pt-2" key={index}><FiArrowRightCircle className="fea icon-sm text-dark me-2"/>{el}</li>
                                    )
                                })}
                            </ul>
                            <div className="bg-light shadow text-center py-4">
                                <Link to="#" className="btn btn-primary">Reserve Now</Link>                                        
                            </div>
                        </div>    
                    </div>
                </div>
            )
        })}
    </div>
  )
}
